import React from 'react';
import { Provider } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Router, Route } from 'react-router-dom';
import store, { history } from './store';
import SiteWrapper from './SiteWrapper';
import ContractFormContainer from './containers/ContractFormContainer';
import ContractsContainer from './containers/ContractsContainer';
import DashboardContainer from './containers/DashboardContainer';
import './App.css';

const App = () => (
  <Provider store={store}>
    <MuiThemeProvider>
      <Router history={history}>
        <SiteWrapper>
          <Route exact path="/" component={DashboardContainer} />
          <Route exact path="/contract/new" component={ContractFormContainer} />
          <Route exact path="/contracts" component={ContractsContainer} />
        </SiteWrapper>
      </Router>
    </MuiThemeProvider>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js